<template>
    <div>
        <div class="modal fade" id="mddetalhesproduto" tabindex="-1" aria-labelledby="mdldetalhesproduto" aria-hidden="true" style="z-index: 1051;">
			<div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="mdldetalhesproduto"><i class="fa fa-info-circle"></i> DETALHES DO PRODUTO {{detprodutos.id}} - {{detprodutos.descricao}}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" style="padding: 10px 0px 10px 0px;">
                        <div class="container-fluid" >
                            <div class="col-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <!-- detalhes -->
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvdetalhes">Detalhes</a>
                                    </li>
                                    <!-- classes de imposto -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvclassesdet">Classes</a>
                                    </li>
                                    <!-- detalhes -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvsimilaridades">Similaridades</a>
                                    </li>
                                    <!-- imagens -->
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvimagensdet">Imagens</a>
                                    </li>
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvdetalhes" class="container-fluid tab-pane active">
                                        <div class="row" id="conteudodet" >
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Código:</label>
                                                <input type="text" class="form-control form-control-sm" v-model="detprodutos.id" style="text-transform: uppercase;" data-bv-group=".group" readonly="true">
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label>Descriçao:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.descricao" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>   
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Referência:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.referencia" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-1 col-lg-1">
                                                <label>Und:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.und" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Marca:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.descmarca" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Grupo:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.descgrupo" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Subgrupo:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.descsubgrupo" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Setor:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.descsetor" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label>Dt cadastro:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.dtcadastro" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <label for="eddtultimavenda">Ult. venda:</label>
                                                <input type="text" v-bind:value="detprodutos.dtultimavenda" disabled
                                                    class="form-control form-control-sm" id="eddtultimavenda">
                                                <div class="dropdown dp-impressao-pedido">
                                                    <i v-show="parseInt(detprodutos.idultimavenda) > 0" class="fa fa-print icon-imprimir-pedido dropdown-toggle" title="Imprimir pedido" data-toggle="dropdown"></i>
                                                    <div class="dropdown-menu">
                                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(detprodutos.idultimavenda, 0)">Padrão</a>
                                                        <a class="dropdown-item" href="#" @click.prevent="mtdimprimirpedido(detprodutos.idultimavenda, 1)">Cupom</a>
                                                    </div>
                                                </div>
                                            </div>
                                           
                                            <div class="col-sm-12 col-md-1 col-lg-1">
                                                <label>Frac.:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="parseInt(detprodutos.fracionado) === 1 ? 'Sim' : 'Não'" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Ncm:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.idncm" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Cest:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.idcest" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                            <div style="padding-top: 20px;" class="col-sm-2 col-md-1 col-lg-1">
                                                <span v-if="parseInt(detprodutos.stpro) === 1" style="background-color: #0acf97;" class="badge badge-primary btn-block badge-pill">Ativo</span>
                                                <span v-else  class="badge badge-danger btn-block badge-pill">Inativo</span>
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label>Especificações:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.especificacao" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                             <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label>Dt. validade:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.dtvalidade" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                             <div class="col-sm-12 col-md-1 col-lg-2">
                                                <label>Und maior:</label>
                                                <input type="text" class="form-control form-control-sm" v-bind:value="detprodutos.descunimaior" data-bv-group=".group" maxlength="50" readonly="true"/>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div style="padding-top: 20px;" class="col-sm-12 col-md-6 col-lg-6">
                                                <div class="row">
                                                    <div style="width: 100%; padding: 20px; border: none;" class="card">
                                                        <div class="card-body">
                                                            <table class="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Códigos</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="detprodutos.codigos.length === 0">
                                                                        <td colspan="1">Sem códigos</td>
                                                                    </tr>
                                                                    <tr v-for="(codigo, indexc) in detprodutos.codigos" :key="indexc" v-else>
                                                                        <td>{{codigo.codigo}}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style="padding-top: 20px;" class="col-sm-12 col-md-6 col-lg-6">
                                                <div class="row">
                                                    <div style="width: 100%; padding: 20px; border: none;" class="card">
                                                        <div class="card-body">
                                                            <table class="table table-striped">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Filial</th>
                                                                        <th>Descrição da Localização</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="detprodutos.localizacoes.length === 0">
                                                                        <td colspan="2">Sem localizações</td>
                                                                    </tr>
                                                                    <tr v-for="(localiza, indexl) in detprodutos.localizacoes" :key="indexl" v-else>
                                                                        <td>{{localiza.fantasia}}</td>
                                                                        <td>{{localiza.desclocalizacao}}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <label>Observações:</label>
                                                        <textarea class="form-control center" rows="8" id="txtobs" v-model="detprodutos.observacoes" disabled></textarea>
                                                    </div>
                                                </div>
                                            </div>  
                                        </div>
                                    </div>
                                    <div id="dvsimilaridades" class="container-fluid tab-pane">
                                        <!-- similaridades -->   
                                        <div class="col-md-12">
                                            <div class="card card-in">
                                                <div class="card-header">PRODUTOS SIMILARES À: {{ detprodutos.id }} - {{ detprodutos.descricao }}</div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                                    <thead class="thead-light">
                                                    <tr>
                                                        <th>Código:</th>
                                                        <th>Descrição:</th>
                                                        <th>Und:</th>
                                                        <th>Referência:</th>
                                                        <th>Pr. Tabela:</th>
                                                        <th>Estoque</th>                                                                                                
                                                    </tr>
                                                    </thead>
                                                    <tbody v-show="isloadingtable" style="font-weight: normal;">
                                                        <tr>                                                          
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /></td>
                                                            <td><skeleton-loader-vue style="" type="rect" :width="40" :height="20" animation="fade" /> </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-show="!isloadingtable" style="font-weight: normal;">
                                                        <tr v-for="(produto, index) in lstsimilares" v-bind:key="index">                                                        
                                                            <td>{{ produto.id }}</td>
                                                            <td>{{ produto.descricao }}</td>
                                                            <td>{{ produto.und }}</td>
                                                            <td>{{ produto.referencia }}</td>
                                                            <td style="text-align: right;"><strong>{{formatavalores(produto.prtabela)}}</strong></td>
                                                            <td style="text-align: right;">{{ produto.quantidade }}</td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-show="lstsimilares.length === 0 && !isloadingtable" style="font-weight: normal;">
                                                        <tr >                                                        
                                                            <td colspan="6" style="text-align: center;" >Sem similaridades</td>
                                                        </tr>
                                                    </tbody>
                                                    
                                                </table>
                                            </div>                                                        
                                        </div>                        
                                        <div class="col-md-10">
                                        </div>                  
                                    </div>

                                    <div id="dvclassesdet" class="container-fluid tab-pane">
                                        <div style="width: 100%; padding: 20px; border: none;" class="card">
                                            <div class="card-body">
                                                <table class="table table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>Filial</th>
                                                            <th>Classe</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-if="detprodutos.classes.length === 0">
                                                            <td colspan="2" style="text-align: center;">Sem classes de imposto definidas</td>
                                                        </tr>
                                                        <tr v-for="(classe, indexc) in detprodutos.classes" :key="indexc" v-else>
                                                            <td>{{classe.fantasia}}</td>
                                                            <td>{{classe.idcfop +" - "+ classe.descclasse}}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="dvimagensdet" class="container-fluid tab-pane">
                                        <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                            <div v-if="detprodutos.imagens.length > 0" class="row">
                                                <div v-for="(imagem, index) in detprodutos.imagens" v-bind:key="index" class="col-md-2 text-center" style="margin-bottom: 15px;">
                                                    <img style="object-fit: cover; width: 200px !important; height: 200px; padding: 30px;"  v-bind:src="pathimgview+imagem.patharquivo">
                                                </div>
                                            </div>
                                            <div v-else class="row">
                                                <div class="col-md-12 text-center">
                                                    <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>					                            
                        </div>
					</div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>					
				</div>
			</div>
		</div>
    </div>
    
</template>
<script>
import util from '../utilitarios/util.js'
import VueBootstrap4Table from 'vue-bootstrap4-table'
import VueSkeletonLoader from 'skeleton-loader-vue';
export default {
    name: 'cmpdetalhesprodutos',
    components:{
        VueBootstrap4Table,
        VueSkeletonLoader,
    },
    props:[
        'idproduto'
    ],
    data: function() {
        return {
            detprodutos: {
                id: '',
                descricao: '',
                referencia: '',
                und: '',
                descmarca: '',
                descgrupo: '',
                descsubgrupo: '',
                descsetor: '',
                dtcadastro: '',
                dtultimavenda: '',
                idultimavenda: 0,
                fracionado: 0,
                idncm: '',
                idcest: '',
                stpro: 0,
                especificacao: '',
                observacoes: '',
                codigos: [],
                localizacoes: [],
                classes: [],
                imagens: [],
                similaridades: [],
            },
            pathimgview         : this.$store.state.configpaths.pathimagens,
            isloadingtable      : false,
            money				: {
                decimal         : ',',
                thousands       : '.',
                prefix          : '',//aqui colocar o cifrão se for necessário
                precision       : 2,
                masked          : false, 
            },        
            lstsimilares        : [],     
        };
    },
    methods: {
        mtdimprimirpedido(idpedido, tp){
            window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
                        this.$store.state.filialpadrao.idcliente+
                        '&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
                        this.$store.state.usuario.id, '_blank');
        },
        mtdvisualizarestoque(){
            $('#mdestoqueproduto2').modal('show');
        },
        mtdformatavalordecimal(valor, digitos){
            return util.formatavalordecimais(valor, digitos);
        }, 
        formatavalores:function (val) {
            return util.formatarvalor(val, '');
        },  
        mtdcarregaprodutos(){
            var vself       = this;
            let loader      = this.$loading.show();
            let filtro      = ' and p.id='+vself.idproduto;
            let parametros  = [
                {parametro: 'idclientesac',             valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'diretorioimagens',         valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',                       valor : 'listagem'},
                {parametro: 'filtro',                   valor : filtro},
                {parametro: 'limit',                    valor : '1'},
				{parametro: 'offset',                   valor : '0'},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
            retorno.then(function (response) {
                console.log(response.data)
                vself.detprodutos = response.data[0];
                vself.mtdvisualizarsimilares();
                loader.hide();
            }).catch(function (response) {
                vself.detprodutos = [];
                loader.hide();
            });
        },
        // mtdvisualizarsimilares(){                                
        //     let vself           = this;
        //     let referencias = '';

        //     this.isloadingtable = true;
        
        //     for (let i = 0; i < vself.dadosprodutos.similaridades.length; i++) {
        //         referencias = referencias + vself.dadosprodutos.similaridades[i].referencia + "', '";
        //     }
        //     referencias = "'"+referencias.slice(0, referencias.length - 3);
        //     let parametros      = [
        //         {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
        //         {parametro: 'op',               valor : 'listarsimilares'},
        //         {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
        //         {parametro: 'idtabela',         valor : vself.$store.state.filialpadrao.idtabela},
        //         {parametro: 'idestoque',        valor : vself.$store.state.filialpadrao.idestoque},                    
        //         {parametro: 'referencias',      valor : referencias},
        //         {parametro: 'idproduto',        valor : vself.dadosprodutos.id}
        //     ];
        //     let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
        //     retorno.then(function (response) {
        //         if (response.data.length === 0){
        //             vself.$toastr.i('Não há produtos similares a este!', 'Informação!');
        //             vself.isloadingtable = false;
        //         }else{
        //             vself.lstsimilares = [];
        //             vself.lstsimilares = response.data;
        //             vself.isloadingtable = false;
        //         }
        //     }).catch(function (response) {
        //         vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
        //         vself.isloadingtable = false;
        //     });
        // },
        mtdformatarzeros(str, length){
			return util.formatarzeros(str, length);
		},  
        mtdvisualizarsimilares(){                                
            let vself           = this;
            let referencias = '';

            this.isloadingtable = true;
        
            for (let i = 0; i < vself.detprodutos.similaridades.length; i++) {
                referencias = referencias + vself.detprodutos.similaridades[i].referencia + "', '";
            }
            referencias = "'"+referencias.slice(0, referencias.length - 3);
            let parametros      = [
                {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',               valor : 'listarsimilares'},
                {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                {parametro: 'idtabela',         valor : vself.$store.state.filialpadrao.idtabela},
                {parametro: 'idestoque',        valor : vself.$store.state.filialpadrao.idestoque},                    
                {parametro: 'referencias',      valor : referencias},
                {parametro: 'idproduto',        valor : vself.detprodutos.id}
            ];
            let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
            retorno.then(function (response) {
                if (response.data.length === 0){
                    vself.isloadingtable = false;
                }else{
                    vself.lstsimilares = [];
                    vself.lstsimilares = JSON.parse(JSON.stringify(response.data));
                    vself.isloadingtable = false;
                }
            }).catch(function (response) {
                vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                vself.isloadingtable = false;
                vself.lstsimilares = [];
            });
        },            
        mtddefinicoes(){   
            let vself       = this;
            $("#mddetalhesproduto").on('show.bs.modal', function(){
                vself.mtdcarregaprodutos();
            });
            $("#mddetalhesproduto").on('hide.bs.modal', function(){
                vself.dadosprodutos = [];        
            });
        }
    },
    mounted: function() {
        this.mtddefinicoes();
    },    
    computed:{ 
    },
    watch: {
        idproduto: {
            immediate: true,
            handler(novoValor) {
                if (novoValor) {
                    console.log("ID Produto atualizado:", novoValor);
                    this.mtdcarregaprodutos();
                }
            }
        }
    }
}
</script>
<style>
    #span-atraso{
        position: relative;
        float: right;
        top: -22px;
        left: -5px;
        margin-bottom: -15px;
    }
</style>